import * as Yup from 'yup';

export const AccountInitialValues = {
  username: '',
  first_name: '',
  last_name: '',
};

export const AccountSchema = Yup.object().shape({
  username: Yup.string()
    .matches(
      /^[a-zA-Z0-9_-]{3,20}$/,
      'Username must be 3-20 characters long and can contain letters, numbers, underscores, and hyphens'
    )
    .required('Username is required'),
  first_name: Yup.string()
    .max(50, 'First name must be at most 50 characters')
    .required('First name is required'),
  last_name: Yup.string()
    .max(50, 'Last name must be at most 50 characters')
    .required('Last name is required'),
});

export const ChangePasswordInitialValues = {
  oldPassword: '',
  newPassword: '',
  confirmNewPassword: '',
};

export const ChangePasswordSchema = Yup.object().shape({
  oldPassword: Yup.string().required('Old Password is required'),
  newPassword: Yup.string().required('New Password is required'),
  confirmNewPassword: Yup.string()
    .required('Confirm New Password is required')
    .oneOf([Yup.ref('newPassword'), null], 'Password must match'),
});

export const ChangeEmailInitialValues = {
  old_email: '',
  new_email: '',
};

export const ChangeEmailSchema = Yup.object().shape({
  old_email: Yup.string()
    .email('Must be a valid email')
    .max(255)
    .required('Old Email is required'),

  new_email: Yup.string()
    .email('Must be a valid email')
    .max(255)
    .required(' New Email is required'),
});

export const WritingStyleInitialValues = {
  key: '',
  writing_style_full: '',
  website_url_scrape: '',
  tone: '',
  address: '',
  sentence_structure: '',
  vocabulary: '',
  sources: '',
  excerpt: '',
  is_default: false,
};
export const WritingStyleSchema = Yup.object().shape({
  key: Yup.string().required("Un nom pour votre style d'écriture est requis").max(80),
  writing_style_full: Yup.string().max(20000),
  website_url_scrape: Yup.string().url("La valeur entrée doit être un url valide"),
  tone: Yup.string().max(100),
  address: Yup.string().max(100),
  sentence_structure: Yup.string().max(5000),
  vocabulary: Yup.string().max(5000),
  sources: Yup.string().max(5000),
  excerpt: Yup.string().max(1500),
  is_default: Yup.boolean(),
});

export const CompanyInitialValues = {
  key: '',
  company_full: '',
  website_url_scrape: '',
  name: '',
  description: '',
  audience: '',
  website: '',
  offers: '',
  positioning: '',
  is_default: false,
};
export const CompanySchema = Yup.object().shape({
  key: Yup.string().required('Un nom est requis').max(80),
  company_full: Yup.string().max(20000),
  website_url_scrape: Yup.string().url("La valeur entrée doit être un url valide"),
  name: Yup.string().max(100),
  description: Yup.string().max(500),
  audience: Yup.string().max(500),
  website: Yup.string().url('Format d’URL invalide'),
  offers: Yup.string().max(2000),
  positioning: Yup.string().max(2000),
  is_default: Yup.boolean(),
});


export const ProductInitialValues = {
  key: '',
  name: '',
  description: '',
  is_default: false,
  link: '',
};

export const ProductSchema = Yup.object().shape({
  key: Yup.string().required('Product Name is required'),
  name: Yup.string().required('Name is required'),
  description: Yup.string().required('Description is required'),
  is_default: Yup.boolean().required('Default Style is required'),
  link: Yup.string()
    .url('Invalid URL format')
    .required('Website URL is required'),
});

export const LinkOpenAIInitialValues = {
  apiKey: '',
};

export const LinkOpenAISchema = Yup.object().shape({
  apiKey: Yup.string()
    .matches(
      /^sk-.+/,
      "Votre clé API OpenAI est toujours composée des caractères 'sk-' suivis par une chaine de nombres et de lettres"
    )
    .required('Une clé API openai est requise pour connecter votre compte !'),
});

export const LinkPerplexityInitialValues = {
  apiKey: '',
};

export const LinkPerplexitySchema = Yup.object().shape({
  apiKey: Yup.string()
    .matches(
      /^pplx-.+/,
      "Votre clé API Perplexity est toujours composée des caractères 'pplx-' suivis par une chaine de nombres et de lettres"
    )
    .required('Une clé API Perplexity est requise pour connecter votre compte !'),
});
